<div
  *ngIf="visible"
  class="banner"
  [ngClass]="'banner-' + type"
  [class.cta]="actionLabel"
  [@fadeIn]="animationState"
  (@fadeIn.done)="onAnimationDone($event)"
>
  <ds-icon [icon]="icon" class="icon"></ds-icon>

  <div class="text-banner">
    <span class="message" [innerHTML]="sanitizedMessage"></span>
    <span *ngIf="actionLabel" class="action-label" (click)="onAction()">{{ actionLabel }}</span>
  </div>
  <ds-icon *ngIf="!actionLabel && closeable" icon="cross" class="close-icon" (click)="close()"></ds-icon>
</div>
